import Guide03 from "@/styles/assets/images/img_guide03.png";
import { Form } from "@/components/organisms/Form";
import { Buttons } from "@/components/atoms/Buttons";
import { showAlert } from "@/components/containers/Alert";
import { useNavigate } from "react-router";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { JoinProcessBar } from "@/components/atoms/JoinProcessBar";
import { PhotoGuideItem } from "@/components/atoms/PhotoGuideItem";
import { photoAgreeState } from "@/common/states/agree";
import { spineImageState } from "@/common/states/image";
import { useEffect, useRef } from "react";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import { useRecoilValue, useSetRecoilState } from "recoil";

export const PhotoGuide03Page = () => {
  const agree = useRecoilValue(photoAgreeState);
  const imgRef = useRef<any>();
  const navigate = useNavigate();
  const setImage = useSetRecoilState(spineImageState);

  useEffect(() => {
    if (!agree) {
      navigate("/");
    }
  }, [agree, navigate]);

  const onChangeImg = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    try {
      const imgFile = e.target.files[0];
      setImage(imgFile);
      navigate("/spine/photo-preview", { replace: true });
    } catch (error) {
      showAlert("이미지 촬영에 실패하였습니다. 다시 시도해주세요.");
    }
  };

  useEffect(() => {
    const handleImageSelected = async (event: any) => {
      try {
        const { base64, fileName } = event.detail;

        const response = await fetch(base64);
        const blob = await response.blob();
        const file = new File([blob], fileName, { type: "image/jpeg" });

        setImage(file);

        navigate("/spine/photo-preview", { replace: true });
      } catch (error) {
        console.error("Image processing error:", error); // 에러 확인
        showAlert("이미지 처리에 실패하였습니다. 다시 시도해주세요.");
      }
    };

    window.addEventListener("imageSelected", handleImageSelected);
    return () =>
      window.removeEventListener("imageSelected", handleImageSelected);
  }, [setImage, navigate]);

  return (
    <MainTemplate
      nav={false}
      subPage={true}
      menuBtn={false}
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="건강"
          onClick={() => navigate("/spine")}
        />
      }
      pageTitle="척추 사진 촬영"
    >
      <Form
        processBar={<JoinProcessBar stepNow={4} stepTotal={5} />}
        title="척추 사진 촬영 가이드"
        text={
          <>
            아래 가이드에 따라 사진 등록을 진행해 주세요.
            <br />
            <span>
              ※ 셀프 촬영이 어려운 경우, 가족의 도움을 받아 진행합니다.
            </span>
          </>
        }
        submitBtn={
          <Buttons
            type="button"
            size="lg"
            color="primary100"
            layout="solid"
            disabled={false}
            onClick={() => navigate("/spine/photo-guide04")}
            label="다음"
          />
        }
        backBtn={
          <Buttons
            type="button"
            size="lg"
            color="primary100"
            layout="text"
            label="뒤로"
            onClick={() => window.history.back()}
          />
        }
      >
        <>
          <input
            id="cameraFile"
            ref={imgRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={onChangeImg}
          />
          <PhotoGuideItem
            data={{
              img: Guide03,
              text: (
                <>
                  <div>
                    카메라가&nbsp;
                    <b>등의 정면</b>을 바라보도록
                    <br />
                    위치를 조절하여 촬영합니다.
                  </div>
                </>
              ),
            }}
          />
        </>
      </Form>
    </MainTemplate>
  );
};
